export default __webpack_public_path__ + "static/media/pot5.238f098a.svg";